export default __webpack_public_path__ + "static/media/bail-proj-img.f0b9bab7.png";